import { useState } from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { CompetenciesCompetenciesListDocument } from 'generated/resources/graphql'

import { useCallback } from 'modules/core/hooks/useCallback'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { NewCompetencyModal } from 'modules/competencies/components/NewCompetencyModal'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { CompetenciesDataTable } from './CompetenciesDataTable'
import { NewCompetencyWizard } from './NewCompetencyWizard'
import SetUpCompetencies from './SetUpCompetencies'

const CompetenciesList = () => {
  const [showNewCompetencyWizard, setShowNewCompetencyWizard] = useState(false)
  const { company } = useCurrentSession()

  const { data, loading } = useQuery(CompetenciesCompetenciesListDocument, {
    variables: {
      companyId: company.id,
    },
  })
  const hasCompetencies = (data?.competencies.competenciesConnection.totalCount ?? 0) > 0

  const isCompetenciesRevampEnabled =
    data?.features.featuresConnection.nodes.some(
      (feature) => feature.name === 'dev_competencies_revamp'
    ) ?? false

  const CreateCompetencyModal = useCallback(() => {
    if (!showNewCompetencyWizard) return null

    if (isCompetenciesRevampEnabled) {
      return (
        <NewCompetencyModal
          onClose={() => setShowNewCompetencyWizard(false)}
          onSuccess={() => setShowNewCompetencyWizard(false)}
        />
      )
    }

    return (
      <NewCompetencyWizard
        isCompetenciesRevampEnabled={isCompetenciesRevampEnabled}
        onClose={() => setShowNewCompetencyWizard(false)}
      />
    )
  }, [isCompetenciesRevampEnabled, showNewCompetencyWizard])

  if (loading) {
    return (
      <Box height="full" padding="s24" justifyContent="center" alignItems="center">
        <Spinner />
      </Box>
    )
  }

  if (!hasCompetencies) {
    return (
      <>
        <SetUpCompetencies onNewCompetency={() => setShowNewCompetencyWizard(true)} />
        <CreateCompetencyModal />
      </>
    )
  }

  return (
    <ResponsivePage.Body>
      <CompetenciesDataTable
        filterOptions={{
          jobs: data?.jobCatalog.roles || [],
          competencyGroups: data?.competencies.competencyGroups || [],
        }}
        isCompetenciesRevampEnabled={isCompetenciesRevampEnabled}
        onNewCompetency={() => setShowNewCompetencyWizard(true)}
      />
      <CreateCompetencyModal />
    </ResponsivePage.Body>
  )
}

export default CompetenciesList
